import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { UpcomingBookingSummaryQuery } from '../gql/graphql';

const upcomingBookingSummaryQuery = graphql(/* GraphQL */ `
  query upcomingBookingSummary($userId: String!) {
    upcomingBookingSummary(userId: $userId) {
      arrivalAirport
      arrivalTime
      boatName
      boatPhoto
      departureAirport
      departurePier
      departureTime
      disembarkationDate
      diveCount
      embarkationDate
      guestCount
      returnPier
      routeName
      tripId
      bookingStatus
      bookingId
      boatSlug
      boatId
      isLeadGuest
      guestNumber
    }
  }
`);

const useUpcomingBookingSummary = (userId: string) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, isLoading, error } = useQuery<UpcomingBookingSummaryQuery>({
    queryKey: ['upcomingBookingSummary', userId],
    queryFn: async () =>
      graphqlRequest<UpcomingBookingSummaryQuery>(
        upcomingBookingSummaryQuery,
        {
          userId,
        },
        isAuthenticated ? getAccessTokenSilently : undefined,
      ),
    enabled: isAuthenticated,
    staleTime: 3600000, // 1 hour
    retry: shouldRetryQuery,
  });

  return {
    upcomingBookings: data?.upcomingBookingSummary || [],
    isLoading,
    error,
  };
};

export default useUpcomingBookingSummary;
